import { render, staticRenderFns } from "./plus-button.component.vue?vue&type=template&id=3cf26c22&scoped=true&"
import script from "./plus-button.component.vue?vue&type=script&lang=ts&"
export * from "./plus-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./plus-button.component.vue?vue&type=style&index=0&id=3cf26c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf26c22",
  null
  
)

export default component.exports